export * from './courses.module';
export * from './lesson';
export * from './lesson.service'; // Try the full import path if this shortcut causes errors
export * from './course.service'; // Try the full import path if this shortcut causes errors